import { LEDGER_ENTRY_TYPE } from 'Data/payments.js'

export function getView(entry) {
  switch (entry.type) {
    case LEDGER_ENTRY_TYPE.ADJUSTMENT:
    case LEDGER_ENTRY_TYPE.CHARGE:
      return 'Aggregated'
    case LEDGER_ENTRY_TYPE.APPLIED_PAYMENT:
    case LEDGER_ENTRY_TYPE.CHARGE_TRANSFER:
    case LEDGER_ENTRY_TYPE.INSTALLMENT_CHARGE:
    case LEDGER_ENTRY_TYPE.PAYMENT_PLAN:
    case LEDGER_ENTRY_TYPE.PAYMENT_PLAN_ROLLBACK:
    case LEDGER_ENTRY_TYPE.TRANSFER_CHARGE:
    case LEDGER_ENTRY_TYPE.UNAPPLIED_PAYMENT:
      return 'Single'
    default:
      return 'No'
  }
}
